import { useEffect, useState } from "react";
import TapHelper from "../../../services/TapHelper";

const SessionTimer = ({ children, onExpire }) => {
    const [time, setTime] = useState("");

    useEffect(() => {
        let seconds = Number(TapHelper.getPasscodeExpiry()) || 0;

        const update = () => {
            const min = String(Math.floor(seconds / 60)).padStart(2, "0");
            const sec = String(seconds % 60).padStart(2, "0");
            setTime(`${min}:${sec}`);
        };

        update();

        const timer = setInterval(() => {
            if (seconds <= 0) {
                clearInterval(timer);
                onExpire?.();
                return;
            }

            seconds--;
            TapHelper.setPasscodeExpiry(seconds);
            update();
        }, 1000);

        return () => clearInterval(timer);
    }, [onExpire]);

    return children(time);
};

export default SessionTimer;